import { useCallback, useState } from 'react';

import { Button, Nav, NavItem } from 'reactstrap';

import classnames from 'classnames';

import { userStore } from '@p/security/users/store/store';

const UserTabs = () => {
  const { setTab } = userStore();
  const [groupTab, setGroupTab] = useState(0);
  const userTabs = ['All', 'ABTeam', 'AccountManagers', 'Blitz', 'ClearWord', 'NOVA', 'POD', 'Sunrise', 'TechTeam'];
  const handleOnTabClick = useCallback(
    (value: number, selectedTab: string) => {
      setGroupTab(value);
      setTab(selectedTab);
      // Object.keys(groupTabs).forEach((key) => {
      //   if (key === selectedTab) {
      //     return console.log('selectedTab: ', key);
      //   }
      // });
    },
    [setTab]
  );

  return (
    <Nav>
      {userTabs.map((item, index) => {
        return (
          <NavItem key={item}>
            <div className="ms-3 ">
              <Button
                className={classnames({ active: groupTab === index })}
                color="outline-primary btn-rounded"
                onClick={() => handleOnTabClick(index, item)}>
                {item}
              </Button>
            </div>
          </NavItem>
        );
      })}
    </Nav>
  );
};

export default UserTabs;
